import { CustomButton } from 'holistic-resources';
import { MdLogout } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { toggleAppOverlay, toggleLoadingAppOverlay, resetUISlice } from 'reducers/ui/uiSlice';
import { resetCurrentUserSlice } from 'reducers/currentUser/currentUserSlice';
import { resetPaymentFormSlice } from 'reducers/paymentForm/paymentFormSlice';
import { resetSettingsSlice } from 'reducers/settingsSlice';
import { logout } from 'services/ApiService';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';

export default function SignOutButton({ className = '' }) {
  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();
  const { componentConfig } = useSelector(
    (state) => state.ui,
  );
  const dispatch = useDispatch();

  const onSignoutHandler = async () => {
    dispatch(toggleLoadingAppOverlay(true));
    try {
      const tempIdpSecurityEnabled = componentConfig.idpSecurityEnabled;
      dispatch(toggleAppOverlay(false));
      dispatch(resetUISlice());
      dispatch(resetCurrentUserSlice());
      dispatch(resetPaymentFormSlice());
      dispatch(resetSettingsSlice());
      await logout(tempIdpSecurityEnabled);
      window.location.href = `${ROUTES_SELF_SERVICE.LOGIN}`;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CustomButton className={className} onClick={onSignoutHandler}>
      <div className="flex items-center gap-2">
        <div
          style={{ backgroundColor: secondaryColour }}
          className="p-2 text-white rounded-full"
        >
          <MdLogout />
        </div>
        <div className="font-medium">Sign out</div>
      </div>
    </CustomButton>
  );
}
